<template>
  <div>
    <MainNavigation />
    <nuxt />
    <BikeAddModal />
    <EditBikeModal />
    <QuickQuoteModal />
    <CongratsModal />
    <Footer />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import { mapGetters, mapActions } from 'vuex'
import MainNavigation from '@/components/MainNavigation'
import BikeAddModal from '@/components/modals/BikeAdd'
import EditBikeModal from '@/components/modals/EditBike'
import QuickQuoteModal from '@/components/modals/QuickQuote'
import Footer from '@/components/common/Footer'
import CongratsModal from '@/components/modals/Congrats'
import BuildBadge from '@/components/common/BuildBadge'

import { buildSeoHead } from '@/helpers/seo'
import { buildSocialMeta } from '@/helpers/social-meta'

// Ghost custom fields (og_image, twitter_image) hold a path relative to the
// Ghost admin's own domain, not ours - so they're resolved to an absolute
// Ghost URL here, before buildSocialMeta ever sees them. Its own guard only
// knows how to join a bare path onto pedalsure.com, which would be wrong for
// these.
const GHOST_DOMAIN = 'https://philiplochner.ghost.io'

export default {
  components: {
    BuildBadge,
    MainNavigation,
    BikeAddModal,
    EditBikeModal,
    QuickQuoteModal,
    CongratsModal,
    Footer,
  },
  async middleware({ store, redirect, route }) {
    console.log('route.name', route.name)
    await store.dispatch('blog/loadPage', route.name)
  },
  data() {
    return {}
  },
  head() {
    const seo = buildSeoHead(this.$route.path)
    // Was built from $route.name, which is the route identifier rather than
    // the URL; the canonical helper is the single source of truth now.
    const path = this.$route.path
    // Ghost lets an editor set a different title/image per network; each
    // fallback chain picks one CMS-authored value, which is then the single
    // value both tags for that network are built from - never a second,
    // separately-typed string.
    const title = this.page.og_title || this.page.meta_title || this.page.title
    const description =
      this.page.og_description ||
      this.page.twitter_description ||
      this.page.meta_description
    const image = this.page.og_image
      ? `${GHOST_DOMAIN}${this.page.og_image}`
      : this.page.twitter_image
      ? `${GHOST_DOMAIN}${this.page.twitter_image}`
      : this.page.feature_image

    return {
      title: this.page.title,
      link: seo.link,
      meta: [
        ...seo.meta,
        {
          hid: 'description',
          name: 'description',
          content: this.page.meta_description,
        },
        { hid: 'title', name: 'title', content: this.page.title },
        { hid: 'keywords', name: 'keywords', content: this.codeInjectedMeta() },
        ...buildSocialMeta({
          title,
          description,
          path,
          image,
          type: 'article',
        }).meta,
      ],
    }
  },
  computed: {
    ...mapGetters({ page: 'blog/page' }),
  },

  beforeMount() {
    setTimeout(() => {
      if (document.getElementById('get-quote-static-button')) {
        document
          .getElementById('get-quote-static-button')
          .addEventListener('click', this.openQuickQuteModal)
      }
    }, 3000)
  },
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', false)
  },
  methods: {
    ...mapActions('quote', {
      resetQuote: 'resetQuote',
    }),
    openQuickQuteModal() {
      this.resetQuote()
      this.$modal.show('quick-quote')
    },
    codeInjectedMeta() {
      const regex = /<meta name="keywords" content="(.*?)">/gm
      let m
      const keywords = []

      while ((m = regex.exec(this.page.codeinjection_head)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
          regex.lastIndex++
        }
        keywords.push(m[1])
      }
      return keywords.join()
    },
  },
}
</script>

<style lang="scss">
#get-quote-static-button {
  display: block;
  margin: 0 auto;
  width: 100%;
  font-size: 20px;
  &:hover {
    color: white;
  }
}
</style>

<style lang="scss" scoped>
.logo {
  font-size: 1.3rem;
  color: $white;
}
</style>
